var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { keys, includes } from 'lodash';
import * as React from 'react';
import * as moment from 'moment';
import * as qs from 'query-string';
import { connect } from 'react-redux';
import { Query, Mutation } from 'react-apollo';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, Icon, IconButton } from '@material-ui/core';
import { VideoPlayerWithLoader, VideoPlayer } from 'src/components/reusable/VideoPlayer';
import styles from './VideoEmbedCodes.styles';
import { getTranslation } from 'src/translation';
import { getVideoDuration } from 'src/utils/cards';
import Animate from '../../../theme/components/Animate';
import { replaceTranslationSkipCharacters, replaceBreaks } from 'src/utils/common';
import { getVideoEmbed } from 'src/gql/getVideoEmbed';
import { addAnonymousAnalyticsMutation, addAnonymousAnalyticsVariables } from 'src/gql/addAnonymousAnalytics';
import * as classNames from 'classnames';
import '../../../styles/index.css';
// @ts-ignore
var PublicEmbed = /** @class */ (function (_super) {
    __extends(PublicEmbed, _super);
    function PublicEmbed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isInfoExpanded: false,
        };
        return _this;
    }
    PublicEmbed.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, hasActiveSubscription = _a.hasActiveSubscription, translate = _a.translate, tubeColor = _a.tubeColor, logo = _a.logo;
        var renderItemWithLink = function (component, linksToShow) {
            return (React.createElement("div", { className: classes.linkParentWrapper },
                React.createElement("div", { className: classes.linkInner },
                    component,
                    _this.state.isInfoExpanded ? (React.createElement("div", { className: classNames(classes.expandedLink) },
                        React.createElement("div", { className: "ds-flex", style: { fontSize: 24 } },
                            React.createElement("div", { className: "ml--15" }, translate('related-link')),
                            React.createElement("div", { className: "ml-auto", style: { cursor: 'pointer' } },
                                React.createElement(Icon, { onClick: function () { return _this.setState({ isInfoExpanded: false }); } }, "close"))),
                        (linksToShow || [])
                            .filter(function (chapterLink) { return !!chapterLink.link && !!chapterLink.link.url && !!chapterLink.link.url.trim(); })
                            .map(function (chapterLink) { return (React.createElement("div", { className: classNames('ds-flex flex-column align-center mt-25 w-75', classes.linkWrapper), onClick: function () { return window.open(chapterLink.link.url, '_blank'); } },
                            React.createElement("div", { title: chapterLink.link.title, className: classes.linkTitleWrapper, style: { color: tubeColor } }, chapterLink.link.title),
                            React.createElement("div", { className: classNames(classes.link) }, translate('open-link')))); }))) : (React.createElement(React.Fragment, null, !!(linksToShow || []).filter(function (chapterLink) { return !!chapterLink.link && !!chapterLink.link.url && !!chapterLink.link.url; }).length && (React.createElement("div", { 
                        // style={{ top: showFavoritesIcon ? 90 : 50 }}
                        className: classNames('ds-flex', classes.expandView, classes.infoBtn, classes.expandViewHover), onClick: function () { return _this.setState({ isInfoExpanded: true }); } },
                        React.createElement("span", { className: classes.viewProgress }, translate('related-link')),
                        React.createElement(IconButton, { className: classNames(classes.chartButton) },
                            React.createElement(Icon, null, "info")))))))));
        };
        return (React.createElement(Query, __assign({}, getVideoEmbed(window.location.href
            .split('?')[0]
            .split('/')
            .pop(), this.props.orgId)), function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading) {
                return (React.createElement("p", { style: { background: 'white', width: '100%', height: '100%' } }, _this.props.translate('loading')));
            }
            if (error) {
                // @ts-ignore
                var message = error.networkError.result ? error.networkError.result.message : error.message;
                return (React.createElement("div", { className: "flex flex-col flex-1 items-center justify-center p-16" },
                    React.createElement("div", { className: "max-w-512 text-center" },
                        React.createElement(Animate, { delay: 500 },
                            React.createElement(Typography, { variant: "headline", color: "textSecondary", className: "mb-16 capitalize" }, message)),
                        React.createElement(Animate, { delay: 600 },
                            React.createElement(Typography, { variant: "subheading", color: "textSecondary", className: "mb-48" }, _this.props.translate('video-not-found'))))));
            }
            var _b = data.getFromEmbedRes, abstract = _b.abstract, createdAt = _b.createdAt, description = _b.description, name = _b.name, duration = _b.duration, type = _b.type, renderingData = _b.renderingData;
            var subtitles = keys(renderingData || {}).reduce(function (r, lang) {
                if (!renderingData[lang].subtitles)
                    return r;
                return __spreadArray(__spreadArray([], r), [
                    {
                        language: lang,
                        chapters: renderingData[lang].subtitles.map(function (data) { return (__assign(__assign({}, data), { manuscript: replaceBreaks(replaceTranslationSkipCharacters(data.manuscript)) })); }),
                    },
                ]);
            }, []);
            var videoDuration = duration ? getVideoDuration(duration / 1000) : null;
            var createdAtDate = moment(new Date(createdAt)).format('MMMM Do, YYYY');
            var isIframe = includes(window.location.href, '/sharing/embed/');
            var parsedQuerySting = qs.parse(location.search);
            var subTitleLang = parsedQuerySting && parsedQuerySting.subTitleLang;
            var masterLang = data.getFromEmbedRes.masterLanguage;
            var linksToShow = renderingData &&
                renderingData[data.getFromEmbedRes.language] &&
                renderingData[data.getFromEmbedRes.language].videoLinks
                ? renderingData[data.getFromEmbedRes.language].videoLinks
                : renderingData && renderingData[masterLang] && renderingData[masterLang].videoLinks
                    ? renderingData[masterLang].videoLinks
                    : [];
            return data.getFromEmbedRes.publicEmbed ? (React.createElement(Mutation, __assign({}, addAnonymousAnalyticsMutation(_this.props.orgId)), function (addAnonymousAnalyticsReq) {
                if (loading) {
                    return (React.createElement("p", { style: { background: 'white', width: '100%', height: '100%' } }, _this.props.translate('loading')));
                }
                if (error) {
                    return React.createElement("p", null, error.message);
                }
                return (React.createElement("div", { style: { background: 'white', width: '100%', height: '100%', overflow: 'auto' } }, isIframe ? (React.createElement("div", null, renderItemWithLink(React.createElement(VideoPlayer, { isEmbedVideo: true, source: data.getFromEmbedRes.url, videoDuration: videoDuration, ribbonType: type, tubeColor: 'rgb(0,0,0,0.8)', showTTLogo: isIframe, links: linksToShow, isVideoLinksFeatureEnabled: true, thumbnail: data.getFromEmbedRes.thumbnail, subtitlesLang: subTitleLang, mainLanguage: data.getFromEmbedRes.language, onPlaybackEvent: function (event, time) {
                        addAnonymousAnalyticsReq(addAnonymousAnalyticsVariables({
                            type: event,
                            payload: event === 'videoTimeWatched'
                                ? {
                                    videoId: data.getFromEmbedRes.videoId,
                                    time: time,
                                    version: data.getFromEmbedRes.lastVersion,
                                    lang: data.getFromEmbedRes.language,
                                }
                                : {
                                    videoId: data.getFromEmbedRes.videoId,
                                    version: data.getFromEmbedRes.lastVersion,
                                    lang: data.getFromEmbedRes.language,
                                },
                        }));
                    }, voiceOver: subtitles }), linksToShow))) : (React.createElement("div", { className: classes.bodyWrapper },
                    React.createElement("div", { className: classes.headerWrapper },
                        React.createElement("img", { onClick: function () {
                                return !hasActiveSubscription && (window.location.href = 'https://www.launchpeople.com/');
                            }, className: classes.logoImg, style: hasActiveSubscription ? { cursor: 'default' } : {}, src: hasActiveSubscription ? logo : '/assets/images/logos/training-tube.png' }),
                        !hasActiveSubscription ? (React.createElement(Button, { style: { backgroundColor: '#A6419A' }, onClick: function () {
                                window.location.href = 'https://www.trainingtube.com/booking-a-demo';
                            }, className: classes.trainingTubeRedirect }, _this.props.translate('get-training-tube'))) : (React.createElement(Button, { style: { backgroundColor: '#A6419A' }, onClick: function () {
                                window.location.href = "https://www.trainingtube.com/login?redirectTo=/&commingFrom=" + _this.props.orgId;
                            }, className: classes.trainingTubeRedirect }, _this.props.translate('login')))),
                    React.createElement("div", { className: classes.cardWrapper },
                        React.createElement("div", { className: classes.innerCard },
                            React.createElement("div", { className: "embedded-player  " + classes.videoWrapper }, renderItemWithLink(React.createElement("div", { style: {
                                    width: '100%',
                                    height: '100%',
                                } },
                                React.createElement(VideoPlayer, { isEmbedVideo: true, subtitlesLang: subTitleLang, mainLanguage: data.getFromEmbedRes.language, source: data.getFromEmbedRes.url, videoDuration: videoDuration, ribbonType: type, links: linksToShow, isVideoLinksFeatureEnabled: true, tubeColor: 'rgb(0,0,0,0.8)', thumbnail: data.getFromEmbedRes.thumbnail, onPlaybackEvent: function (event, time) {
                                        addAnonymousAnalyticsReq(addAnonymousAnalyticsVariables({
                                            type: event,
                                            payload: event === 'videoTimeWatched'
                                                ? {
                                                    videoId: data.getFromEmbedRes.videoId,
                                                    time: time,
                                                    version: data.getFromEmbedRes.lastVersion,
                                                    lang: data.getFromEmbedRes.language,
                                                }
                                                : {
                                                    videoId: data.getFromEmbedRes.videoId,
                                                    version: data.getFromEmbedRes.lastVersion,
                                                    lang: data.getFromEmbedRes.language,
                                                },
                                        }));
                                    }, voiceOver: subtitles })), linksToShow)),
                            React.createElement("div", { className: classes.videoName }, replaceTranslationSkipCharacters(name)),
                            React.createElement("div", { className: classes.videoAbstract }, replaceTranslationSkipCharacters(abstract)),
                            React.createElement("div", { className: classes.imageContainer },
                                React.createElement("div", { className: classes.videoCreatedDate },
                                    React.createElement("div", null, createdAtDate))),
                            description !== '<p><br></p>' && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: classes.descriptionTitle }, _this.props.translate('description')),
                                React.createElement("div", { className: classes.descriptionBody, dangerouslySetInnerHTML: {
                                        __html: replaceTranslationSkipCharacters(description),
                                    } })))))))));
            })) : (React.createElement(VideoPlayerWithLoader, { isEmbedVideo: true, lang: data.getFromEmbedRes.language, subtitlesLang: subTitleLang, mainLanguage: data.getFromEmbedRes.language, masterLanguage: data.getFromEmbedRes.masterLanguage, videoId: data.getFromEmbedRes.videoId, lastVersion: data.getFromEmbedRes.lastVersion, source: data.getFromEmbedRes.url, thumbnail: data.getFromEmbedRes.thumbnail, subtitles: subtitles }));
        }));
    };
    PublicEmbed = __decorate([
        withStyles(styles),
        connect(function (state, ownProps) {
            return __assign(__assign({}, ownProps), { tubeId: state.auth.tube.id, orgId: ownProps.orgId || state.auth.organization.id || state.auth.user.data.organization.id, translate: getTranslation(state.translation.lang), tubeColor: state.auth.tube.color });
        })
    ], PublicEmbed);
    return PublicEmbed;
}(React.Component));
export default PublicEmbed;



//////////////////
// WEBPACK FOOTER
// ./src/components/routes/embed/PublicEmbedPage.tsx
// module id = 2055
// module chunks = 81